import React, { Component } from 'react';


class CheckboxList extends Component{
    constructor(props){
        super(props);
        this.state = {
            listValues:null
        }

        this.generateList = this.generateList.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.sendData = this.sendData.bind(this);
    }

    componentWillMount(){
        if(this.state.listValues == null){
            this.setState({
                listValues: this.props.config.data
            })
        }
    }

    componentDidUpdate(prevProps,nextState){
        const currentTable = this.props.config.selectedTable;
        if(currentTable !== prevProps.config.selectedTable){
            this.setState({
                listValues:this.props.config.data
            });
        }
    }

    sendData(){
        this.props.getData(this.state.listValues);
    }



    handleChange(e){
        let currentState = this.state.listValues;

        let target = e.target.name;
        let value = null;
        
        if (e.target.checked){
            value = 1;
        }
        else{
            value = 0;
        }
        currentState[target] = value;
        this.props.getData(this.state.listValues);
    }

    generateList(){
        let that = this;
        let listObj = this.props.config.data;
        let checkList = [];
        for (let key in listObj) {
            if (listObj.hasOwnProperty(key)) {
                let checkedValue = listObj[key];
                if (checkedValue == 1) {
                    checkedValue = true;
                }
                else {
                    checkedValue = false;
                }

                checkList.push(
                    <li key={`${key}_list`} className="list-group-item">
                        <div key={`${key}_checkbox_div`} className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" name={key} id={`${key}_checkbox`} onChange={that.handleChange} checked={checkedValue} />
                            <label className="custom-control-label" htmlFor={`${key}_checkbox`}>{key}</label>
                        </div>
                    </li>
                )
            }
        }
        return checkList;
    }

    render(){
        let checkList = this.generateList();
        return (
            <>
                <ul className="list-group checklist">
                     {checkList}
                </ul>
            </>
        )
    }
}

export default CheckboxList;